const mainClass = "help-character-counter";

const CharacterCounter = ({
	id,
	text,
	maxCharacterLength,
	characterCounterLabel = "",
}) => {
	return (
		<span
			className={`${mainClass}`}
			id={`${id}-char-count`}
		>{`${text.length}/${maxCharacterLength} ${characterCounterLabel}`}</span>
	);
};

export default CharacterCounter;
